import React from "react";
import EducationTimeline from "../elements/EducationTimeline";

function Education() {
  return (
    <section className="section" id="education">
      <div className="container">
        <h1 className="title">Education</h1>
        <EducationTimeline />
      </div>
    </section>
  );
}

export default Education;